<template>
    <o-field>
        <o-autocomplete
            v-model="query"
            placeholder="Global search"
            has-custom-template
            :data="results"
            field="title"
            icon="search-web"
            type="search"
            @select="handleSelect"
            @input="handleSearch"
            max-results="1000"
        >
            <template #default="props">
                <div class="media">
                    <div class="media-content">
                        {{  $filters.stripTags(props.option.title)}}
                        <br>
                        <small>
                            Type: <strong>{{ props.option.type }}</strong>
                        </small>
                    </div>
                </div>
            </template>
        </o-autocomplete>
    </o-field>
</template>

<script>
import { mapActions } from 'vuex'
    import { getApplicationTabNameByType } from '../utils'
    export default {
        data() {
            return {
                query: '',
                selected: null,
                results: []
            }
        },

        watch: {
            $route (to, from) {
                this.query = ''
            }
        },

        methods: {
            ...mapActions(['setForceRouteKey']),
            handleSearch:
                _.debounce(function () {
                    if (this.query && this.query.length > 1) {
                        let params = {q: this.query}
                        axios.get('/api/search', { params })
                            .then(res => {
                                this.results = res.data.data
                                return { data: { data: this.results }}
                            })
                    } else {
                        this.results = [];
                    }
                }, 250),
            handleSelect(item) {
                if (item) {
                    this.selected = null
                    this.query = ''
                    this.setForceRouteKey(true)
                    this.$router.push(this.itemUrl(item))
                }
            },

            itemUrl(item) {
                let id = item.id

                if(item.type.indexOf('application') !== -1){
                    return {
                        name: 'projects.show.applications.tab',
                        params: {
                            tabParam: getApplicationTabNameByType(item.reference_type),
                            slug: item.reference_id,
                        }
                    }
                }

                switch (item.type) {
                    case 'contact':
                        return `/companies/${item.reference_id}?contact_id=${id}`
                    case 'project':
                        return `/projects/${id}`
                    case 'proposal':
                        return `/proposals/${id}`
                    case 'company':
                        return `/companies/${id}`
                    case 'task':
                        return `/tasks/${id}`
                    case 'user':
                        return `/users/${id}`
                    case 'note':
                        return item.reference_type === 'project' ?
                            `/projects/${item.reference_id}/notes` :
                            `/tasks/${item.reference_id}`
                }
            }
        }
    }
</script>
